import React from 'react'
import { FormField, FormFieldLabel, Input, Modal } from '../../../ui'

interface InputModalInterface {
  message: string,
  showModal: boolean,
  title?: string,
  action?: string,
  handleOnClose: () => void
  handleOnConfirm: () => void,
  handleOnInputChange: (value) => void,
  defaultInputValue: number,
  inputValue: number,
  inputType: React.HTMLInputTypeAttribute,
  errorNotfication?: string
}

export default function InputModal({ inputValue, errorNotfication, handleOnConfirm, showModal, handleOnClose, message, action, title, handleOnInputChange, inputType, defaultInputValue }: InputModalInterface) {
  if (!message) {
    return null;
  }

  const renderMessage = () => {
    return (
      <>
        <p data-testid='test-modal-message'>
          {message}
        </p>
        <FormField
          labelForId="test-form-input"
          labelText="Enter amount for refund"
          type="input"
          testId='testInputText'
        >
          <Input
            id="test-refund-input"
            testId='testInputField'
            placeholder="Refund amount"
            noBackground
            onChange={e => handleOnInputChange(e.target.value)}
            defaultValue={defaultInputValue}
            value={inputValue}
            type={inputType}
            max={defaultInputValue}
          />
        </FormField>
        {
          errorNotfication && (
            <FormFieldLabel testId="errorTripsLabel" className='Error'>{errorNotfication}</FormFieldLabel>)
        }
      </>
    )
  }

  return <>
    <Modal
      shown={showModal}
      onClose={handleOnClose}
      onConfirm={handleOnConfirm}
      buttonConfirmLabel={action ? action : 'Ok'}
      buttonConfirmText={action ? action : 'Ok'}
      title={title ? title : `Action`}
      large={false}
      status='info'
      testId='test-message-modal'>
      {renderMessage()}
    </Modal>
  </>
}
